import { NORMS } from "../../content/norms";
import { profile } from "../../state/store";

/** PB table, each paired with a cited reference band where one exists. */
export function RecordsTable() {
  const b = profile.value.bests;
  const bestWpmEntry = Object.entries(b.wpmByCard).sort((a, c) => c[1] - a[1])[0];
  const phonationNorm = NORMS.find((n) => n.id === "phonation-time");

  const rows: { label: string; value: string; norm?: (typeof NORMS)[number] }[] = [
    { label: "Max phonation time", value: b.phonationSec ? `${b.phonationSec}s` : "—", norm: phonationNorm },
    { label: "Breath ladder record", value: b.breathCount ? String(b.breathCount) : "—" },
    { label: "Plosive timing accuracy", value: b.plosiveAccuracy ? `${b.plosiveAccuracy}%` : "—" },
    { label: "Steadiness", value: b.steadinessPct ? `${b.steadinessPct}%` : "—" },
    { label: "Best twister WPM", value: bestWpmEntry ? `${bestWpmEntry[1]} (${bestWpmEntry[0]})` : "—" },
  ];

  return (
    <div class="records-table">
      {rows.map((row) => (
        <div key={row.label} class="records-row">
          <div class="records-row-main">
            <span class="records-label">{row.label}</span>
            <span class="mono records-value">{row.value}</span>
          </div>
          {row.norm && (
            <p class="records-norm">
              {row.norm.label}: {row.norm.low}–{row.norm.high} {row.norm.unit}. {row.norm.note}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
